import React from 'react'
import { Trans } from 'react-i18next'

import ITranslationKeys from './translations/ITranslationKeys'

type Props = { i18nKey: keyof ITranslationKeys | `error.${string}`, language?: string, [key: string]: unknown }
const Translate: React.FC<Props>  = ({ i18nKey, language,  ...rest }) => {
  return <Trans i18nKey={i18nKey as string} tOptions={{ lng: language }} {...rest} />
}
export default Translate
